import React from "react";
import { cn } from "@/lib/utils";

export default function PageHeader({ title, subtitle, actions, breadcrumbs, className, testId }) {
  return (
    <div data-testid={testId} className={cn("mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between", className)}>
      <div>
        {breadcrumbs && (
          <div className="text-xs text-gray-500 mb-2 font-mono uppercase tracking-widest">{breadcrumbs}</div>
        )}
        <h1 className="font-display text-2xl md:text-3xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-gray-400 mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
